import {
    nudgeReasonReceivedDaysAgo,
    nudgeReasonSentDaysAgo,
} from './getNudgedReason.locstring.json';
import loc, { format } from 'owa-localize';
import NudgedReason from '../store/schema/NudgedReason';
import nudgeStore from '../store/Store';

export default function getNudgedReason(rowKey: string): string {
    const nudgedRow = nudgeStore.nudgedRows.filter(nudgedRow => nudgedRow.rowKey === rowKey)[0];

    switch (nudgedRow.reason) {
        case NudgedReason.ReceivedDaysAgo:
            return format(loc(nudgeReasonReceivedDaysAgo), nudgedRow.daysAgo);
        case NudgedReason.SentDaysAgo:
            return format(loc(nudgeReasonSentDaysAgo), nudgedRow.daysAgo);
    }
}
